<template>
  <cos-modal
    v-model:visible="visible"
    title="发券申请"
    width="670px"
    :confirm-loading="loading"
    @ok="handleBecomeInvalidOk"
  >
    <a-form :model="dataForm" ref="formRef" v-if="visible">
      <a-form-item name="idList" label="审核客户">
        <CosSelect
          v-model:value="dataForm.idList"
          :options="selectedData"
          :fieldNames="{ label: 'customerName', value: 'id' }"
          disabled
          mode="multiple"
          :max-tag-count="100"
        />
      </a-form-item>
      <a-form-item name="reviewStatus" label="审批状态" :rules="[{ required: true, message: '请输入' }]">
        <a-radio-group v-model:value="dataForm.reviewStatus" name="reviewStatus">
          <a-radio value="2">通过</a-radio>
          <a-radio value="3">驳回</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        name="reviewComments"
        label="审核意见"
      >
        <CosInput v-model:value="dataForm.reviewComments" :maxlength="200" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<any[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const toggle = (data: any[]) => {
  if (!data.length) return DcMessage.error('请先选择发券申请')
  if (data.find((item: any) => item.reviewStatus !== 1)) return DcMessage.error('请选择待审核的发券申请')
  dataForm.value = {
    idList: data.map((item: any) => item.id)
  }
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['success'])
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    request
      .post('lbu/api/coupons/audit', dataForm.value)
      .then(() => {
        DcMessage.success('发券审核成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
defineExpose({ toggle })
</script>
<script lang="ts">
export default { name: 'AuditCouponModal' }
</script>
